import { motion } from "framer-motion";
import { fadeUp } from "./motion";

const IMG = {
  padel:
    "https://images.unsplash.com/photo-1554068865-24cecd4e34b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxwYWRlbCUyMHRlbm5pcyUyMGFjdGlvbiUyMHBsYXllcnxlbnwwfHx8fDE3ODY5OTUwMzR8MA&ixlib=rb-4.1.0&q=85",
  running:
    "https://images.unsplash.com/photo-1718248028293-934f04a578db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxydW5uZXIlMjBzcG9ydHMlMjBhY3Rpb24lMjBwaG90b2dyYXBoeXxlbnwwfHx8fDE3ODY5OTUwNDB8MA&ixlib=rb-4.1.0&q=85",
  sunglasses:
    "https://images.unsplash.com/photo-1489659831163-682b5af42225?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxzcG9ydHMlMjBzdW5nbGFzc2VzJTIwZmFzaGlvbiUyMHJ1bm5pbmd8ZW58MHx8fHwxNzg2OTk1MDQwfDA&ixlib=rb-4.1.0&q=85",
};

const ImageCard = ({ img, num, title, sub, span, testId, custom }) => (
  <motion.div
    custom={custom}
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: "-80px" }}
    className={`group relative overflow-hidden ${span}`}
    data-testid={testId}
  >
    <img
      src={img}
      alt={title}
      className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[filter,transform] duration-700 ease-out"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
    <div className="absolute bottom-0 left-0 p-6 lg:p-8 text-white">
      <span className="text-[10px] uppercase tracking-[0.3em] font-bold text-[#EAB308]">{num}</span>
      <h3 className="font-display font-bold uppercase tracking-tight text-3xl mt-1">{title}</h3>
      <p className="text-sm text-white/70 mt-1">{sub}</p>
    </div>
  </motion.div>
);

const TypeCard = ({ num, title, sub, bg, text, span, testId, custom }) => (
  <motion.div
    custom={custom}
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: "-80px" }}
    className={`group flex flex-col justify-between p-6 lg:p-8 min-h-[240px] ${bg} ${text} ${span}`}
    data-testid={testId}
  >
    <span className="text-[10px] uppercase tracking-[0.3em] font-bold opacity-70">{num}</span>
    <div>
      <h3 className="font-display font-bold uppercase tracking-tight text-3xl group-hover:translate-x-2 transition-transform duration-500 ease-out">
        {title}
      </h3>
      <p className="text-sm opacity-70 mt-1">{sub}</p>
    </div>
  </motion.div>
);

const Verticals = () => (
  <section id="verticales" className="py-24 lg:py-36 px-6 lg:px-12 bg-white border-y border-black/10" data-testid="verticals-section">
    <div className="max-w-[1600px] mx-auto">
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        className="mb-16 lg:mb-24 max-w-3xl"
      >
        <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#DB2777]">Verticales</span>
        <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-4">
          Cinco frentes,<br /><span className="font-serif-accent normal-case tracking-normal text-[#DB2777]">una obsesión</span><span className="text-[#EAB308]">.</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-12 auto-rows-[280px] lg:auto-rows-[320px] gap-4">
        <ImageCard img={IMG.padel} num="V.01 — Desde 2018" title="Padel" sub="El vertical fundacional de Rocky" span="md:col-span-7 md:row-span-2" testId="vertical-padel" custom={0} />
        <ImageCard img={IMG.running} num="V.02 — Desde 2022" title="Running Gear" sub="Equipamiento para correr sin límites" span="md:col-span-5" testId="vertical-running" custom={1} />
        <ImageCard img={IMG.sunglasses} num="V.03 — Desde 2023" title="Sunglasses" sub="Incluyendo la marca goodr" span="md:col-span-5" testId="vertical-sunglasses" custom={2} />
        <TypeCard num="V.04" title="Golf" sub="Precisión dentro y fuera del campo" bg="bg-[#EAB308]" text="text-[#0A0A0A]" span="md:col-span-4" testId="vertical-golf" custom={3} />
        <TypeCard num="V.05" title="Water Sports" sub="Rendimiento en cada ola" bg="bg-[#0A0A0A]" text="text-white" span="md:col-span-8" testId="vertical-watersports" custom={4} />
      </div>
    </div>
  </section>
);

export default Verticals;
